import React, {Component} from "react";
import MassiveAgreementView from "./MassiveAgreementView";
import {MassiveAgreementService} from "../../../service/operation/massiveAgreement/MassiveAgreementService";
import {Growl} from "primereact/growl";
import ConfirmationMessage from "../../../components/confirmationMessage"
import {Button} from "primereact/button";

export default class MassiveAgreementContainer extends Component {
    constructor(props) {
        super(props);
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        this.massiveAgreementService = new MassiveAgreementService();
        this.loading = this.loading.bind(this);
        this.onChangeFilters = this.onChangeFilters.bind(this);
        this.getMessages = this.getMessages.bind(this);
        this.deleteMessages = this.deleteMessages.bind(this);
        this.onSelectionChangeTable = this.onSelectionChangeTable.bind(this);
        this.setGuarantees = this.setGuarantees.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.openConfMsg = this.openConfMsg.bind(this);
        this.errorTemplate = this.errorTemplate.bind(this);
        this.showErrorMessage = this.showErrorMessage.bind(this);
        this.onHideErrorDialog = this.onHideErrorDialog.bind(this);
        this.onHideGuaranteeDialog = this.onHideGuaranteeDialog.bind(this);
        this.saveGuarantee = this.saveGuarantee.bind(this);
        this.getLoanGuarantees = this.getLoanGuarantees.bind(this);
        this.onChangeGuarantee = this.onChangeGuarantee.bind(this);

        this.state = {
            isLoading: true,
            filters: {
                lender: {},
                borrower: {},
                instrument: {},
                idOrigin: '',
                idPresval: '',
                catStatus: {}
            },
            catalogs: {
                catLender: [],
                catBorrower: [],
                catInstrument: [],
                catStatus: [],
            },
            messagesList: [],
            selectedMessages: [],
            selectedForGuarantee: {},
            guarantees:[],
            rowError:{},
            displayErrorDialog: false,
            displayGuaranteeDialog: false
        };
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }
    clearFilters() {
        this.setState({
            filters: {
                lender: {},
                borrower: {},
                instrument: {},
                idOrigin: '',
                idPresval: '',
                catStatus: {}
            },
            selectedMessages: [],

        });

    }
    onChangeFilters(event) {
        let filtersAux = this.state.filters;
        filtersAux[event.target.name] = event.target.value ? event.target.value : "";
        this.setState({
            filters: filtersAux,
        });
    }

    onChangeGuarantee(event) {
        let selectedGuaranteeAux = this.state.selectedForGuarantee;
        selectedGuaranteeAux = event.target.value ? event.target.value : "";
        this.setState({
            selectedForGuarantee: selectedGuaranteeAux,
        });
    }
    onSelectionChangeTable(event) {
        this.setState({selectedMessages: event.value,})
    }

    componentDidMount() {
        this.getCatLender();
        this.getCatBorrower();
        this.getCatInstrument();
        this.getCatStatus();

    }
    getCatLender() {
        this.loading(true);
        this.massiveAgreementService.getCatLender()
            .then(response => {
                let catalogsAux = this.state.catalogs;
                catalogsAux['catLender'] = response;
                this.setState({
                    catalogs: catalogsAux,
                });
                this.loading(false);
            });
    }
    getCatBorrower() {
        this.loading(true);
        this.massiveAgreementService.getCatBorrower()
            .then(response => {
                let catalogsAux = this.state.catalogs;
                catalogsAux['catBorrower'] = response;
                this.setState({
                    catalogs: catalogsAux,
                });
                this.loading(false);
            });
    }
    getCatInstrument() {
        this.loading(true);
        this.massiveAgreementService.getCatInstrument()
            .then(response => {
                let catalogsAux = this.state.catalogs;
                response.map(item => {
                    item['label'] = item['instrument'] + " " + item['series'] +
                        " " + item['valueType'] + " " + item['coupon']
                    return item;
                });
                catalogsAux['catInstrument'] = response;
                this.setState({
                    catalogs: catalogsAux,
                });
                this.loading(false);
            });
    }
    getCatStatus() {
        this.loading(true);
        this.massiveAgreementService.getCatStatus()
            .then(response => {
                let catalogsAux = this.state.catalogs;
                catalogsAux['catStatus'] = response;
                this.setState({
                    catalogs: catalogsAux,
                });
                this.loading(false);
            });
    }

    getMessages() {
        this.loading(true);
        this.massiveAgreementService.getMessages(this.state.filters)
            .then(response => {
                this.setState({
                    messagesList: response,
                    selectedMessages: [],
                });
                this.loading(false);
                if (response === undefined || response.length === 0) {
                    this.growl.show({
                        severity: 'info', summary: 'Info.',
                        detail: "No hay datos"
                    });
                }
            });
    }

    deleteMessages() {
        if (this.state.selectedMessages === undefined || this.state.selectedMessages.length === 0)  {
            this.growl.show({
                severity: 'info', summary: 'Info.',
                detail: "No hay mensajes seleccionados."
            });
        } else {
            alert("Delete Messages")
        }

    }

    setGuarantees() {
        let selectedMessages = this.state.selectedMessages;
        if (this.state.selectedMessages === undefined || this.state.selectedMessages.length === 0)  {
            this.growl.show({
                severity: 'info', summary: 'Info.',
                detail: "No hay mensajes seleccionados."
            });
        } else if (this.validateRowsForGuarantees(selectedMessages)!== undefined) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: "No se puede garantizar con estado diferente de  \"Concertado\"."
            });
        } else if (selectedMessages.length >= 1) {
            this.getLoanGuarantees();
        }
    }
    getLoanGuarantees() {
        this.loading(true);
        this.massiveAgreementService.getGuarantees()
            .then(response => {
                response.map(item => {
                    item['label'] = item['instrument'] + " " + item['series'] +
                        " " + item['valueType'] + " " + item['coupon'];
                    return item;
                });
                this.setState({
                    guarantees: response,
                    displayGuaranteeDialog: true
                });
                this.loading(false);
            });
    }

    validateRowsForGuarantees(selectedRows) {
        return selectedRows.find(elem => {
            return elem.status !== "Concertado";
        });
    }

    saveGuarantee(){
        let selectedMessages = this.state.selectedMessages;
        let selectedGuarantee = this.state.selectedForGuarantee;
        if(selectedGuarantee === undefined || selectedGuarantee.instrument === undefined){
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: "Seleccionar una garantía."
            });
        } else {
            let idSelected = selectedMessages.reduce((str, item) => `${str} ${item.idPresval}, `, '');
            alert("Garantizar " + idSelected + "con una garantía: " + selectedGuarantee.instrument);
            this.massiveAgreementService.saveLoanGuarantee().then(response =>{
                this.getMessages();
                this.onHideGuaranteeDialog();
            });
        }
    }

    openConfMsg() {
        if (this.confirmationRef) {
            this.confirmationRef.openConfirmationMessage();
        }
    }
    errorTemplate(rowData, column){
        if (rowData['status'] === "Error") {
            return <Button label="Error" onClick={() => this.showErrorMessage(rowData)}/>
        } else {
            return <div>{rowData['status']}</div>;
        }
    }

    showErrorMessage(rowData){
        this.setState({
            displayErrorDialog: true,
            rowError: rowData,
        });
    }

    onHideErrorDialog() {
        this.setState({
            displayErrorDialog: false
        });
    }
    onHideGuaranteeDialog(){
        this.setState({
            displayGuaranteeDialog: false,
            selectedMessages: [],
            selectedForGuarantee: {},
        });
    }


    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        let confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                           invisible={true}
                                           legend="¿Está seguro que desea eliminar las excepciones?"
                                           action={this.deleteMessages}/>;
        return <MassiveAgreementView
            loading={this.loading}
            getMessages={this.getMessages}
            clearFilters={this.clearFilters}
            onChangeFilters={this.onChangeFilters}
            onSelectionChangeTable={this.onSelectionChangeTable}
            setGuarantees={this.setGuarantees}
            openConfMsg={this.openConfMsg}
            errorTemplate={this.errorTemplate}
            onHideErrorDialog={this.onHideErrorDialog}
            onHideGuaranteeDialog={this.onHideGuaranteeDialog}
            onChangeGuarantee={this.onChangeGuarantee}
            saveGuarantee={this.saveGuarantee}

            filters={this.state.filters}
            catalogs={this.state.catalogs}
            isLoading={this.state.isLoading}
            messagesList={this.state.messagesList}
            selectedMessages={this.state.selectedMessages}
            displayErrorDialog={this.state.displayErrorDialog}
            rowError={this.state.rowError}
            displayGuaranteeDialog={this.state.displayGuaranteeDialog}
            guarantees={this.state.guarantees}
            selectedForGuarantee={this.state.selectedForGuarantee}

            messagesGrowl={messagesGrowl}
            confirmationMessage={confMsg}
        />
    }
};
